import Dispatcher from '../dispatcher';
import {InfoPopupActions} from '../constants/info_popup/info_popup_actions';

function showAction() {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SHOW
    });
}

function hideAction() {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.HIDE
    });
}

function setHeaderOnCloseClickAction(onCloseClick) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_HEADER_ON_CLOSE_CLICK,
        payload: onCloseClick
    });
}

function setHeaderContentAction(headerContent) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_HEADER_CONTENT,
        payload: headerContent
    });
}

function addBodyContentAction(bodyContent) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.ADD_BODY_CONTENT,
        payload: bodyContent
    });
}

function setBodyButtonTextAction(bodyButtonText) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_BODY_BUTTON_TEXT,
        payload: bodyButtonText
    });
}

function setBodyButtonOnClickAction(onClick) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_BODY_BUTTON_ON_CLICK,
        payload: onClick
    });
}

function setBodyUpperImagePathAction(upperImagePath) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_BODY_UPPER_IMAGE_PATH,
        payload: upperImagePath
    });
}

function setBodyLowerImagePathAction(lowerImagePath) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_BODY_LOWER_IMAGE_PATH,
        payload: lowerImagePath
    });
}

function showCloseButtonAction(value) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SHOW_CLOSE_BUTTON,
        payload: value
    });
}

function setDispatcherAction(dispatcher) {
    Dispatcher.handleInfoPopupAction({
        type: InfoPopupActions.SET_DISPATCHER,
        payload: dispatcher
    });
}

export {
    showAction,
    hideAction,
    setHeaderContentAction,
    addBodyContentAction,
    setBodyButtonTextAction,
    setBodyButtonOnClickAction,
    setHeaderOnCloseClickAction,
    setBodyUpperImagePathAction,
    setBodyLowerImagePathAction,
    showCloseButtonAction,
    setDispatcherAction
};